import { SizeDataCategory } from './size'

// TODO: Cần dùng Zod để validate response từ API, dùng infer để lấy type từ API
export type Product = {
  _id: string
  apply_allowance_inventory: boolean
  id: string
  title: string
  seo_alias: string
  seo_title?: string
  seo_meta_title: string
  seo_description: string
  seo_keywords: string
  short_desc: string
  in_stock?: number
  vendor: string
  tags: Record<string, string>
  images: ProductImage[]
  onsale: boolean
  available: boolean
  box_exclude?: number
  collections:
    | {
        label: string
        seo_alias: string
        available: boolean
        icon_thumbnail: ProductImage
        images: ProductImage[]
        value: string
      }[]
    | string[]
  price: number
  compare_price: number
  preorder: boolean
  pricing: ProductPricing[]
  is_pricing: boolean
  display_order: number
  sale_number: number
  is_color_image_option: boolean
  youtube_video: string
  addon_note: string
  review: ProductReview
  coming_soon: boolean
  variants: ProductVariant[]
  percent: number
  regular_price: number
  sizechart: string
  sizechart2?: string
  not_random: boolean
  display_name: string
  display_name_open: string
  modified_date: string
  note_collections: string[]
  updated_at: string
  created_at: string
  addon_note_collection: string
  pricing_policy: PricingPolicy
  flash_sale: FlashSale | null
  campaign_sale: CampaignSale | null
  deal_sale: null
  coolclub_sale: CoolClubSale | null
  icon_thumbnail: ProductImage
  collection_pricing_policy: PricingPolicy[]
  ini_sold?: number
  options: ProductOption[]
  options_value: ProductOptionsValue[]
  bread_crumb: BreadCrumbItem[]
  sold_product: number
  spu?: string
  tag_text?: string
  size_guide?: SizeDataCategory
  size_guide_2?: SizeDataCategory
  gender_type?: TGenderType
  tag_label?: string
  product_title_1?: string
  product_title_2?: string
  is_setdo: boolean
  variant_gallery?: boolean
}

export type ProductImageFooter = {
  hide: boolean
  image: string
}

export type BreadCrumbItem = {
  id: string
  seo_alias: string
  title: string
}

export type ProductOptionsValue = {
  title: string
  options_id: string
  options: Option[]
  values: string[]
}

export type Option = {
  title: string
  slug: string
  label: string
  image: ProductImage[]
}

// TODO: sửa lại type
export type FlashSale = {
  _id: string
  product_id: string
  regular_price: string
  from_collection: boolean
  max: number
  variants: Record<string, CampaignSaleVariant[]>
  max_regular_price: string
  flash_sale_id: string
}
export interface CoolClubSale {
  _id: string
  product_id: string
  regular_price: number
  from_collection: boolean
  flash_sale_id: string
  flash_sale: CoolClubFlashSale
  coolclub_price: number
  variants: Record<string, CampaignSaleVariant[]>
  rankings: string[]
}
export interface CoolClubFlashSale {
  _id: string
  title: string
  collection_list: string[]
  collection_max_quantity: number
  flash_sale_type: string
  flash_sale_value: string
  enabled: boolean
  flash_sale: number
  starts_at: string
  ends_at: string
  rankings: string[]
  updated_at: Date
  created_at: Date
}

export type ProductImage = {
  id: string
  src: string
  image: string
  hide?: boolean
}

export type ProductOption = {
  title: string
  option_id: string
  option_sizechart: string
  values: string[]
  values_map: {
    id: number
    value: string
  }[]
}

export type ProductPricing = {
  discount_quantity: number
  discount_price: number
}

export type ProductReview = {
  count: number
  avg: number
  ratingValue: number
  ratingCount: number
  reviewCount: number
  bestRating: number
  worstRating: number
}

export type ProductVariant = {
  _id: string
  id: string
  product_id: string
  title: string
  regular_price: number
  compare_price: number
  quantity: number
  option1: string
  option2: string
  option3: string
  option4: string
  hide: boolean
  pending: number
  available: boolean
  product_title: string
  product_apply_allowance_inventory?: boolean
}

export type PricingPolicy = {
  _id: string
  product_id: string
  description: string
  compare_price: number
  product_label: string
  available: boolean
  coupons_applicable: boolean
  pricing_type: string
  conditions: {
    quantity: number
    value: number
  }[]
  product_pricing_id: string
  updated_at: string
  created_at: string
}

export type CampaignSale = {
  _id: string
  product_id: string
  regular_price: string
  from_collection: boolean
  max: number
  variants: Record<string, CampaignSaleVariant[]>
  max_regular_price: string
  flash_sale_id: string
}

export type CampaignSaleVariant = {
  _id: string
  id: string
  product_id: string
  title: string
  regular_price: string
  compare_price: number
  quantity: number
  hide: boolean
  pending: number
  available: boolean
  product_title: string
  active: boolean
  max: number
  max_quantity: number
  discount_percent: number
  flash_sale_type: 'fixed_amount'
  used?: number
}
export type ProductCollectionResponse = {
  detail: {
    seo_alias: string
    seo_title: string
  }
  products: {
    data: Product[]
    current_page: number
    first_page_url: string
    from: number
    last_page: number
    last_page_url: string
    next_page_url: string
    path: string
    per_page: number
    prev_page_url: string
    to: number
    total: number
  }
  titleDisplay?: string
  // // K hieu, tam thấy thì định nghĩa
  title_display?: string
  request?: {
    color?: string
  }
}

export type ProductCollectionByIdResponse = {
  data: Product[]
  current_page: number
  first_page_url: string
  from: number
  last_page: number
  last_page_url: string
  next_page_url: string
  path: string
  per_page: number
  prev_page_url: string
  to: number
  total: number
}

export type TGenderType = 'MALE' | 'FEMALE'

// ==  Formatted Data để chuẩn hóa API version 4 =====
// TODO: Cần sửa lại, bỏ Product và định nghĩa từng trường cần thiết
export type ProductQueryParams = {
  sort?: string
  random_focus?: boolean
  limit?: number
  color?: string
  page?: number
  prio?: string
  get_seo_content?: boolean
  [key: string]: unknown
  slug?: string
  gender_type?: TGenderType
  getall?: number
  review?: boolean
  visibility?: boolean
  exclude_listing?: boolean
  random?: boolean
  flatten?: number
  force_flatten?: number
  display_collections_variant?: boolean
}

export type ProductResponseFormatted = {
  data: ProductFormatted[]
  is_next_page: boolean
  last_page: number
  current_page: number
  total: number
  // htmlSeoContent?: string
  titleDisplay?: string
  seo_alias: string
  title: string
  request?: {
    color?: string
  }
}

export type ColorsMapped = {
  [key: string]: {
    title: string
    thumbnail: ProductImage
    thumbnail_hover: ProductImage
    image_option: ProductImage
  }
}
export type CoolClubSaleFormatted = {
  active: boolean
  rankings: string[]
  coolclub_price: number
}

export type ProductFormatted = {
  // id: string
  // seo_alias: string
  // // TODO check lại xem note là trường nào
  // addon_note: string
  // tag: string
  // review: ProductReview
  // images: ProductImage[]
  // display_name: string
  // regular_price: number
  // compare_price: number
  // percent: number
  // colors_mapped: ColorsMapped
  // variants_mapped: VariantMapped

  title: string
  href: string
  is_setdo: boolean
  id: string
  regular_price: number
  compare_price: number
  note: string
  mapped_variants: GroupedVariants
  icon_thumbnail?: ProductImage
  sale_percent: number
  active: boolean
  default_thumbnail: string
  default_thumbnail_hover: string
  tags: string[]
  is_free_shipping: boolean
  is_quick_add: boolean
  collections?: string[]
  coolclub_sale?: CoolClubSaleFormatted
  review?: ProductReview
  category?: unknown
  sold_product?: number
  sizechart?: string
  size_guide?: SizeDataCategory
  gender_type?: TGenderType
  display_name_open?: string
  coming_soon?: boolean
  in_stock?: number
}

export type VariantMapped = {
  id: string
  product_id: string
  size: string
  color: string
  quantity: number
  thumbnail: string
  thumbnail_hover: string
  colorImage: string
  isDisable: boolean
  regular_price?: number
  title?: string
}

export type GroupedVariants = Record<string, VariantMapped[]>

export enum ETags {
  PREORDER = 'preorder',
  CLEANDYE = 'cleandye',
  LIMITED_QUANTITY = 'limited-quantity',
  SALE = 'sale',
  BAN_CHAY = 'ban-chay',
  NEW = 'new',
  BESTSELLER = 'best-seller',
  LIMITED = 'limited',
  PREMIUM = 'premium',
  DANG_MUA = 'dang-mua',
}

export enum EGalleryDimension {
  WIDTH = 1440,
  HEIGHT = 1920,
}

export type StupidProduct = Product & { variants_option: ProductVariant[] }

export type ProductSearchResponse = {
  products: Product[]
  pagination: {
    limit: number
    current_page: number
    has_next_page: boolean
  }
}

export type ProductSearchResponseStupid = {
  products: StupidProduct[]
  pagination: {
    limit: number
    current_page: number
    has_next_page: boolean
  }
}

export type X2CoolCashResponse = {
  product_ids: string[]
  collection_list: string[]
  starts_at: string
  ends_at: string
  enable: number
}
